import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/email.css'

const Email = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_qosac6p', 'template_rl7xvu4', form.current, {
                publicKey: 'szs1tgR1IqKMpGf_m',
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                },
                (error) => {
                    console.log('FAILED...', error.text);
                },
            ).then(() => {
                alert("Your email has been sent successfully!");
                document.getElementById("loading").style.display = "none";
            }).catch((error) => {
                console.error("Error writing document: ", error);
            });
    };


    return (
        <div className='emialWrapper'>
            <form
                action="https://formspree.io/f/xblrvzvy"
                method="POST"
            >
                <div>
                    <input type="text" name="name" placeholder='Your Name' />
                </div>

                <div>
                    <input type="email" name="email" placeholder='Email Address' />
                </div>

                <div>
                    <textarea name="message" placeholder='Your Message' rows={5} />
                </div>

                <div className="send">
                    <input type="submit" value="Send" />

                </div>

            </form>
        </div>
    )
}

export default Email
